import type { RefObject } from 'react';
import { Button, Inline } from '@etg/wings';
import { ContentWrapper, variants } from '@eti/components';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';

const bottomContentStyles = css`
  justify-content: space-between;
  width: 100%;
`;

const buttonStyles = css`
  flex: 1;
  height: 48px;

  @media ${mediaQueries.medium.up} {
    flex: initial;
  }
`;

interface YourSelectedTripBottomContentProps {
  onSkipStepClick: () => {};
  onProceedClick: () => void;
  skipButtonRef: RefObject<HTMLButtonElement>;
}

const EtgFaresBottomContent = ({
  onSkipStepClick,
  onProceedClick,
  skipButtonRef,
}: YourSelectedTripBottomContentProps) => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <Inline
        className={bottomContentStyles}
        data-testid="etg-fares-bottom-content"
        noWrap
        spacing={8}
      >
        <Button
          className={buttonStyles}
          data-testid="etgFares-skipStepButton"
          id="skip-step-button"
          onClick={onSkipStepClick}
          ref={skipButtonRef}
          variant={variants.SECONDARY}
        >
          {t('YourSelectedTrip.Page.SkipStepButton.Label')}
        </Button>
        <Button
          className={buttonStyles}
          data-testid="etgFares-proceedButton"
          onClick={onProceedClick}
          variant={variants.PRIMARY}
        >
          {t('YourSelectedTrip.Page.ProceedButton.Label')}
        </Button>
      </Inline>
    </ContentWrapper>
  );
};

export default EtgFaresBottomContent;
